import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import ReactGA from "react-ga4";

import Homepage from "./pages/homepage";
import About from "./pages/about";
import Projects from "./pages/projects";
import Articles from "./pages/articles";
import ReadArticle from "./pages/readArticle";
import Contact from "./pages/contact";
import Admin from "./pages/admin";
import FustellificioFar from "./pages/fustellificioFar";
import Notfound from "./pages/404";

import { ArticlesProvider } from './contexts/ArticlesContext';

import { TRACKING_ID } from "./data/tracking";
import "./app.css";

function App() {
	useEffect(() => {
		if (TRACKING_ID !== "") {
			ReactGA.initialize(TRACKING_ID);
		}
	}, []);

	return (
        <ArticlesProvider> {/* Wrap the entire application or at least the Routes in ArticlesProvider */}
            <div className="App">
                <Routes>
                    <Route path="/" element={<Homepage />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/swapstamp" element={<Projects />} />
                    <Route path="/articles" element={<Articles />} />
                    <Route path="/article/:slug" element={<ReadArticle />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/fustellificio-far" element={<FustellificioFar />} />
                    <Route path="/fustellificio-far/prodotto/:slug" element={<FustellificioFar />} />
                    <Route path="*" element={<Notfound />} />
                </Routes>
            </div>
        </ArticlesProvider>
	);
}

export default App;
